/* tslint:disable:forin */
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GlobalValidator} from '../global-validator';
import {UserService, LoginStatus, BackendStatus, UserStatus} from '../user.service';
import {Router} from '@angular/router';
import {AppSettingsService} from '../app-settings.service';
import {UAParser} from 'ua-parser-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  disableSubmit = true;
  loading = false;

  loginError = undefined;
  alreadyLoggedHosts: string[];

  defaultLoginErrorMessage = 'Erro ao logar!!';

  backendStatusText = this.userService.backendStatusText;

  year: number;

  formErrors = {
    'username': '',
    'password': ''
  };

  validationMessages = {
    'username': {
      'required': 'Email não informado',
      'incorrectMailFormat': 'Email inválido'
    },
    'password': {
      'required': 'Senha não informada'
    },
    'login': {
      'USER_NOT_FOUND': 'Usuário não encontrado',
      'WRONG_USER_OR_PASSWORD': 'Usuário ou senha incorretos',
      'USER_STILL_LOGGED_ERROR': 'Usuário já esta logado:'
    }
  };

  constructor(private fb: FormBuilder, private userService: UserService, private router: Router,
              private ass: AppSettingsService) {
  }

  ngOnInit() {
    this.buildForm();
    if (localStorage.getItem('username')) {
      this.loginForm.patchValue({'username': localStorage.getItem('username')});
    }
    this.loginForm.valueChanges.debounceTime(1000).subscribe((data) => this.onValueChanges(data));
    this.userService.loginStatus.subscribe((ls: LoginStatus) => {
      this.loading = false;
      if (ls && ls.status === UserStatus.LOGGED) {
        this.ass.headerState.next(true);
        this.ass.menuState.next(true);
        this.router.navigateByUrl('/');
      }
      if (ls && ls.status === UserStatus.NEED_CHANGE_PASS) {
        this.router.navigateByUrl('/changePass');
      }
      if (ls && ls.status === UserStatus.ERROR) {
        this.loginError = this.validationMessages.login[ls.message] || this.defaultLoginErrorMessage;
        if (ls.hosts) {
          this.alreadyLoggedHosts = new Array<string>();
          for (let i = 0; i < ls.hosts.length; i++) {
            const host = ls.hosts[i];
            const parser = new UAParser(host.agent);
            let clientString = 'Browser: ' + parser.getBrowser().name + ' | OS: '
              + parser.getOS().name + ' ' + parser.getOS().version;
            if (parser.getResult().device.model) {
              clientString += ' | ' + parser.getResult().device.vendor + ' ' + parser.getResult().device.model;
            }
            console.log(`Client: ${clientString}`);
            this.alreadyLoggedHosts.push(clientString);
          }
        }
      }
    });
    this.userService.backendStatus.subscribe((backendStatus: BackendStatus) => {
      if (backendStatus === null) {
        this.disableSubmit = true;
      } else {
        this.disableSubmit = backendStatus.status !== 200;
      }
    });
    this.ass.menuState.next(false);
    this.ass.headerState.next(false);
    this.year = (new Date()).getFullYear();
  }

  buildForm() {
    this.loginForm = this.fb.group({
      'username': ['', [Validators.required, GlobalValidator.mailFormatValidator]],
      'password': ['', Validators.required]
    });
  }

  tryLogin(model, isValid: boolean) {
    this.loginError = undefined;
    this.alreadyLoggedHosts = undefined;
    this.userService.login(model.username, model.password);
    this.loading = true;
  }

  onValueChanges(data?: any) {
    const form = this.loginForm;

    for (const field in this.formErrors) {
      // clear previous messages
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          console.log(`got key ${key}`);
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }

    for (const error in this.formErrors) {
      if (error !== '""') {
        console.log(`Error:${JSON.stringify(this.formErrors[error])}`);
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/login/login.component.ts